import './Calculator.css'
import React, { useState, useRef, useEffect } from 'react'
import backspace from '../../assets/backspace.png'

const keypad = [
  { id: 'one', label: '1', type: 'number' },
  { id: 'two', label: '2', type: 'number' },
  { id: 'three', label: '3', type: 'number' },
  { id: 'divide', label: '/', type: 'operation' },
  { id: 'four', label: '4', type: 'number' },
  { id: 'five', label: '5', type: 'number' },
  { id: 'six', label: '6', type: 'number' },
  { id: 'multiply', label: '*', type: 'operation' },
  { id: 'seven', label: '7', type: 'number' },
  { id: 'eight', label: '8', type: 'number' },
  { id: 'nine', label: '9', type: 'number' },
  { id: 'subtract', label: '-', type: 'operation' },
  { id: 'zero', label: '0', type: 'number' },
  { id: 'decimal', label: '.', type: 'decimal' },
  { id: 'add', label: '+', type: 'operation' },
  { id: 'equals', label: '=', type: 'operation' },
]

const keypadKeys = ['Enter', 'Backspace',].concat(keypad.map(k => k.label))

const getKey = (label) => keypad.filter(_ => _['label'] === label)[0]

const joinType = (arr, key) => {
  let newArr = arr.slice()
  newArr[newArr.length - 1] = newArr[newArr.length - 1] + key
  return newArr
}

const mathOperations = (a, s, b) => {
  switch (s) {
    case '+':
      return a + b
    case '-':
      return a - b
    case '/':
      return a / b
    case '*':
      return a * b
    default:
      return 0
  }
}

const Calculator = props => {
  const keypadRef = useRef()
  const clearRef = useRef()
  const displayRef = useRef()
  const [display, setDisplay] = useState([])

  const doMath = () => {
    if (display.length === 0) {
      return
    }

    let steps = display.slice()
    let calc = 0
    let operation = '+'

    if (/[/*-+]/.test(steps[steps.length - 1])) {
      steps.pop()
    }

    do {
      if (operation) {
        calc = mathOperations(calc, operation, parseFloat(steps[0]))
        operation = null
        steps.shift()
      } else {
        operation = steps[0]
        steps.shift()
      }
    } while (steps.length > 0)

    let result = calc.toString().split('.')

    if (result.length > 1 && result[1].length > 4) {
      result[1] = result[1].slice(0, 4)
    }

    setDisplay([result.join('.')])
  }

  const setInputMath = keyLabel => {
    if (keyLabel === '=') {
      doMath()
      return
    }

    let key = getKey(keyLabel)

    if (display.length === 0) {
      if (key.type === 'number') {
        setDisplay(display.concat(key.label))
        return
      }

      if (key.type === 'decimal') {
        setDisplay(display.concat('0' + key.label))
        return
      }

      if (key.type === 'operation') {
        return
      }
    }

    let lastChar = getKey(
      display[display.length - 1].charAt(
        display[display.length - 1].length - 1
      )
    )

    let secondToLast = { label: null, type: null }
    if (display.length > 1) {
      secondToLast = getKey(
        display[display.length - 2].charAt(
          display[display.length - 2].length - 1
        )
      )
    }

    if ((lastChar.type === 'number' && key.type === 'number' &&
      !((lastChar.label === '0' && key.label === '0') ||
        (/^0$/.test(display[display.length - 1]))
      )) ||
      (lastChar.type === 'number' && key.type === 'decimal' &&
        !(/[.]/.test(display[display.length - 1]))) ||
      (lastChar.type === 'decimal' && key.type === 'number') ||
      (lastChar.label === '-' && key.type === 'number' &&
        (/[+*/]/.test(secondToLast.label)))) {

      setDisplay(joinType(display, keyLabel))
      return
    }

    if ((lastChar.type === 'number' && key.type === 'operation') ||
      ((/[+*/]/.test(lastChar.label)) && key.type === 'number') ||
      ((/[+*/]/.test(lastChar.label)) && key.label === '-' &&
        secondToLast.type !== 'operation') ||
      ((secondToLast.type === 'number') && key.type === 'number' &&
        lastChar.label === '-')) {

      setDisplay(display.concat(key.label))
      return
    }

    if (secondToLast.type === 'operation' &&
      lastChar.type === 'operation' &&
      key.type === 'operation') {

      let newDisplay = display.slice()
      newDisplay.pop()
      newDisplay[newDisplay.length - 1] = key.label

      setDisplay(newDisplay)
      return
    }

    if ((lastChar.type === 'operation' && (/[+*/]/.test(key.label))) ||
      ((/^0$/.test(display[display.length - 1])) && key.type === 'number')) {

      let newDisplay = display.slice()
      newDisplay[newDisplay.length - 1] = key.label

      setDisplay(newDisplay)
      return
    }

  }

  const activatePad = key => {
    if (key === 'Backspace') {
      clearRef.current.classList.add('calculator-active')
      setDisplay([])
      return
    }
    keypadRef.current.querySelector('#' + getKey(key).id)
      .classList.add('calculator-active')
    setInputMath(key)
  }

  const deactivatePad = () => {
    while (keypadRef.current.querySelector('.calculator-active') !== null) {
      keypadRef.current.querySelector('.calculator-active')
        .classList.remove('calculator-active')
    }
    clearRef.current.classList.remove('calculator-active')
  }

  const onClick = e => {
    activatePad(e.target.dataset.value)
    setTimeout(deactivatePad, 150)
  }

  const keyPress = e => {
    keypadKeys.forEach(i => {
      if (i === e.key) {
        e.preventDefault()
        activatePad(e.key === 'Enter' ? '=' : e.key)
      }
    })
  }

  useEffect(() => {
    document.addEventListener('keydown', keyPress)
    document.addEventListener('keyup', deactivatePad)
    return () => {
      document.removeEventListener('keydown', keyPress)
      document.removeEventListener('keyup', deactivatePad)
    }
  }, [display])

  useEffect(() => {
    displayRef.current.scroll(
      displayRef.current.scrollWidth, displayRef.current.offsetTop
    )
  }, [display])

  return (
    <div className="calculator-container">
      <div className="calculator-calculator">
        <div className="calculator-display">
          <span id="calculator-display" ref={displayRef}>
            {display.length <= 0 ? '0' : display.join('')}
          </span>
          <img src={backspace}
            alt='clear'
            id="calculator-clear"
            ref={clearRef}
            data-value="Backspace"
            onClick={onClick}
          />
        </div>
        <hr />
        <div className="calculator-keypad" ref={keypadRef}>
          {keypad.map(k => (
            <span id={k.id}
              key={k.id}
              data-value={k.label}
              onClick={onClick}
            >
              {k.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Calculator